import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {

    this.selectedCarIds = [];

    let _this = this;

    let carsCount = this.element.getAttribute("data-count");
    let bulkEditForm = document.getElementsByClassName('bulk-edit-form');
    bulkEditForm.forEach((item)=> {
      item.addEventListener('submit', (event) => {
        let value = item.elements[1].value;
        if(item.elements[1].name == 'cars[location_id]') {
          value = item.elements[1].options[item.elements[1].selectedIndex].innerHTML;
        }
        if(confirm(`${_this.selectedCarIds.length} record kerül frissítésre az alábbi értékkel: ${value}`)){
          return;
        } else {
          event.preventDefault();
          return false;
        }
    })
    });

    let checkboxes = document.getElementsByName('selected_cars');
    checkboxes.forEach((item)=> {
      item.addEventListener('change', (event) => {
        if(this.selectedCarIds.indexOf(item.value) > -1) {
          let index = _this.selectedCarIds.indexOf(item.value);
          console.log(index);
          _this.selectedCarIds.splice(index, 1);
        } else {
          _this.selectedCarIds.push(item.value);
        }
        
        _this.setCarIds();
      });
    });

    let toggle_hidden_rows = document.getElementById('toggle_hidden_rows');

    let showHiddenRows = localStorage.getItem("showHiddenRows");
    if(showHiddenRows && showHiddenRows === 'true') {
      toggle_hidden_rows.checked = true;
      let items = document.getElementsByClassName('c-admin-cars-table__row__hidden');
      localStorage.setItem("showHiddenRows", true);
      items.forEach((item) => {
        item.style.display = 'table-cell';
      });
    }

    toggle_hidden_rows.addEventListener('change', (event) => {
      if (toggle_hidden_rows.checked) {
        let items = document.getElementsByClassName('c-admin-cars-table__row__hidden');
        localStorage.setItem("showHiddenRows", true);
        items.forEach((item) => {
          item.style.display = 'table-cell';
        });
      } else {
        let items = document.getElementsByClassName('c-admin-cars-table__row__hidden');
        localStorage.setItem("showHiddenRows", false);
        items.forEach((item) => {
          item.style.display = 'none';
        });
      }
    });


    let selectAll = document.getElementById('select_all_cars');
    selectAll.addEventListener('change', (event) => {
      console.log(selectAll.checked)
      if (selectAll.checked) {
        _this.selectedCarIds = [];
        checkboxes.forEach((item) => {
          item.checked = true;
          _this.selectedCarIds.push(item.value);
        });


        _this.setCarIds();
      } else {
        _this.selectedCarIds = [];
        checkboxes.forEach((item) => {
          item.checked = false;
        });

        _this.setCarIds();
      }
    })
  }

  setCarIds() {
    let _this = this;
    let setHiddenCheckboxValues = document.getElementsByClassName('hidden-car-ids');
    setHiddenCheckboxValues.forEach((item) => {
      if(_this.selectedCarIds) {
        item.value = _this.selectedCarIds.join(',')
      } else {
        item.value = null;
      }
    });
  }
}
